import React, { useRef, useState } from "react";
import "./Modal.scss"
import moment from "moment";
import EventPaymentContainer from "../EventPaymentContainer";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import secure from "../assets/secure.svg"
const BookingModal = ({ data, onClose, selectedTickets, setIsPaymentLoading, isOrderLoading, setIsOrderLoading, setIsBookingFailed, setShowCheckout }) => {
    const adyenRef = useRef(null);

    const [customerDetails, setCustomerDetails] = useState(
        {
            firstName: "",
            lastName: "",
            emailAddress: "",
            phoneNumber: ""
        }
    )
    const [showPaymentErrorModal, setShowPaymentErrorModal] = useState(false)

    const [errors, setErrors] = useState(
        {
            firstName: "",
            lastName: "",
            emailAddress: "",
            phoneNumber: ""
        }
    )
    const [termsChecked, setTermsChecked] = useState(false)
    const [updatesChecked, setUpdatesChecked] = useState(false)
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        let newErrors = {
            firstName: "",
            lastName: "",
            emailAddress: "",
            phoneNumber: ""

        }
        if (customerDetails.firstName.trim() === "") {
            newErrors.firstName = "*Required";
            valid = false;
        }
        if (customerDetails.lastName.trim() === "") {
            newErrors.lastName = "*Required";
            valid = false;
        }
        if (customerDetails.phoneNumber.trim() === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }
        if (customerDetails.emailAddress.trim() === "") {
            newErrors.emailAddress = "*Required";
            valid = false;
        }
        else if (!validateEmail(customerDetails.emailAddress)) {
            newErrors.emailAddress = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };

    const calculateTotal = () => {
        let total = 0;
        const quantity = selectedTickets?.Quantity || 0;
        const ticket = data?.Seats?.SeatCharges?.find((t) => t.Type === selectedTickets?.ChargeType);
        if (ticket) {
            total += ticket.Amount * quantity;
        }
        return total;
    };
    const getTotalTickets = () => {
        return selectedTickets?.Quantity || 0;
    };
    const onFormDataChanged = (property, value) => {
        setCustomerDetails((prevState) => {
            return {
                ...prevState,
                [property]: value
            }
        })
    }
    const handlePayClick = () => {
        if (adyenRef.current) {
            adyenRef.current.submit();
        }
    };
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const calculateChargedTotal = () => {
        const totalDiscount = data?.Pricing?.TaxPercentage + data?.Pricing?.ServiceFeePercentage;
        let total = totalDiscount > 0 ? (calculateTotal() - (calculateTotal() * totalDiscount / 100)) : calculateTotal()
        return Math.round(total);
    };
    return (
        <div className="BookingModal-overlay" onClick={onClose}>
            <div className="BookingModal-box" onClick={(e) => e.stopPropagation()}>
                <div className="BookingModal-box-header" onClick={(e) => e.stopPropagation()}>
                    <div className="BookingModal-box-header-left">
                        <div className="BookingModal-box-header-left-title">
                            Complete Your Booking
                        </div>
                        <div className="BookingModal-box-header-left-subtitle">
                            You're just a few steps away from securing your spot
                        </div>
                    </div>
                </div>
                <div className="BookingModal-box-container">
                    <div className="BookingModal-box-container-summary">
                        <div className="BookingModal-box-container-summary-header">Order Sumary</div>
                        <div className="BookingModal-box-container-summary-content">
                            <div className="BookingModal-box-container-summary-content-left">
                                <div className="BookingModal-event-title">
                                    {data?.EventTitle}
                                </div>
                                <div className="BookingModal-event-details">
                                    {moment(data?.EventDate).format('Do MMMM YYYY')}
                                </div>
                                <div className="BookingModal-event-details">
                                    {data?.Duration?.StartTime} {data?.Duration?.EndTime ? ` - ${data?.Duration?.EndTime}` : "onwards"}
                                </div>
                                <div className="BookingModal-event-details">
                                    {data?.Venue?.Name}, {data?.Venue?.Location}
                                </div>
                            </div>
                            <div className="BookingModal-box-container-summary-content-left">
                                <div className="BookingModal-event-tickets">{getTotalTickets()} ticket(s)</div>
                                <div className="BookingModal-event-total">£{(calculateChargedTotal() / 100).toFixed(2)}</div>
                                <div className="BookingModal-event-tax">Total including fees & VAT</div>
                            </div>
                        </div>
                    </div>
                    <div className="BookingModal-box-container-payment">
                        <div className="BookingModal-box-container-payment-cont">
                            <div className="BookingModal-box-container-payment-cont-header">
                                Customer Information
                            </div>
                            <div className="BookingModal-box-container-payment-cont-flex">
                                <div style={{ width: "100%" }}>
                                    <input className={"BookingModal-event-input"}
                                        placeholder="First Name"
                                        onChange={
                                            (e) => {
                                                onFormDataChanged('firstName', e.target.value)
                                                handleChange('firstName')
                                            }

                                        } />
                                    <div className="BookingModal-event-error">{errors.firstName}</div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <input className="BookingModal-event-input"
                                        placeholder="Last Name"
                                        onChange={
                                            (e) => {
                                                onFormDataChanged('lastName', e.target.value)
                                                handleChange('lastName')

                                            }
                                        } />
                                    <div className="BookingModal-event-error">{errors.lastName}</div>

                                </div>

                            </div>
                            <div className="BookingModal-box-container-payment-cont-flex">
                                <div style={{ width: "100%" }}>
                                    <input className="BookingModal-event-input"
                                        placeholder="Email Address"
                                        onChange={
                                            (e) => {
                                                onFormDataChanged('emailAddress', e.target.value)
                                                handleChange('emailAddress')
                                            }
                                        } />
                                    <div className="BookingModal-event-error">{errors.emailAddress}</div>
                                </div>
                            </div>
                            <div className="BookingModal-box-container-payment-cont-flex">
                                <div style={{ width: "100%" }}>
                                    <PhoneInput className="BookingModal-event-input"
                                        placeholder="Phone Number"
                                        defaultCountry="GB"
                                        value={customerDetails.phoneNumber}
                                        onChange={
                                            (e) => {
                                                onFormDataChanged('phoneNumber', e)
                                                handleChange('phoneNumber')

                                            }
                                        }
                                    />
                                    <div className="BookingModal-event-error">{errors.phoneNumber}</div>
                                </div>
                            </div>
                            <div className="BookingModal-box-container-payment-cont-flex">
                                <input className="BookingModal-event-input"
                                    value={"United Kingdom"}
                                    disabled />
                            </div>
                        </div>
                        <div className="BookingModal-box-container-payment-cont">
                            <div className="BookingModal-box-container-payment-cont-header">
                                Payment Method
                            </div>
                            <EventPaymentContainer
                                customerDetails={customerDetails}
                                ref={adyenRef}
                                items={selectedTickets}
                                setIsPaymentLoading={setIsPaymentLoading}
                                setShowPaymentErrorModal={setShowPaymentErrorModal}
                                isOrderLoading={isOrderLoading}
                                setIsOrderLoading={setIsOrderLoading}
                                eventID={data?.EventID}
                                total={calculateChargedTotal()}
                                setIsBookingFailed={setIsBookingFailed}
                                setShowCheckout={setShowCheckout} />
                            {showPaymentErrorModal && <div className="BookingModal-event-error">*Please fill all the fields</div>}

                        </div>
                    </div>
                    <div className="BookingModal-box-container-checked">
                        <CustomCheckbox
                            checked={termsChecked}
                            onChange={() => setTermsChecked(!termsChecked)} />
                        <div className="BookingModal-box-container-checked1">

                            I agree to the <span className="BookingModal-box-container-checked2-text">Terms & Conditions </span>and <span className="BookingModal-box-container-checked2-text">Privacy Policy</span>
                        </div>  </div>
                    <div className="BookingModal-box-container-checked">
                        <CustomCheckbox
                            checked={updatesChecked}
                            onChange={() => setUpdatesChecked(!updatesChecked)} />
                        Send me updates about this event and similar experiences
                    </div>
                    <div className="BookingModal-box-container-secure">
                        <img alt="" src={secure} />
                        <div className="BookingModal-box-container-secure-cont">
                            <div className="BookingModal-box-container-secure-cont-header">
                                Secure Payment </div>
                            <div className="BookingModal-box-container-secure-cont-subheader">
                                Your payment information is encrypted and secure
                            </div>
                        </div>
                    </div>
                    <div className="BookingModal-box-container-button">
                        <div className="BookingModal-box-container-button-close"
                            onClick={onClose}>
                            Back to Event
                        </div>
                        <div className={termsChecked ? "BookingModal-box-container-button-pay" : "BookingModal-box-container-button-disable"}
                            onClick={() => {
                                if (validateForm() && termsChecked) {
                                    if (!isOrderLoading) {
                                        handlePayClick()
                                    }
                                }
                            }}>
                            {isOrderLoading ? <div className="loader-btn" /> : ` Complete Payment -£ ${(calculateChargedTotal() / 100).toFixed(2)}`}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default BookingModal